import { createReducer, on } from '@ngrx/store';
import { NavigationActions } from '../actions';
import { NavigationState } from '../state/navigation.state';

export const initialNavigationState: NavigationState = {
  isRedirectFromNonReview: false,
  isRedirectFromReview: false,
};

export const navigationReducer = createReducer(
  initialNavigationState,
  on(NavigationActions.setIsRedirectFromReview, (state, action): NavigationState => ({ ...state, isRedirectFromReview: action.isRedirectFromReview })),
  on(NavigationActions.setIsRedirectFromNonReview, (state, action): NavigationState => ({ ...state, isRedirectFromNonReview: action.isRedirectFromNonReview })),
  on(NavigationActions.resetNavigationState, (state): NavigationState => ({ ...state, ...initialNavigationState }))
);
